export const CATEGORY_NAME = 'Blog'
export const EMPTY_BLOG_IMAGE_PLACEHOLDER_URL =
  'http://wp.streetofcode.sk/wp-content/uploads/2022/09/Group-141.png'
export const RECOMMENDED_POSTS_COUNT = 3
export const TOP_TAGS_COUNT = 8
